/**
 * @file index.jsx
 * @author Rishikesh
 * @date 2024-09-17
 * @description Manages the documents informations and listings
 */
import React, { useState } from "react";
import { Box } from "@mui/material";

import { DocumentList } from "./DocumentList";
import { HeaderSection } from "./HeaderSection";
import { useFetchData } from "../../../components/hooks/useFetchData";

const Documents = () => {
  const [minLoading, setMinLoading] = useState(true);
  const [documentList, setDocumentList] = useState([]);

  const { fetchData, loading } = useFetchData();

  const getAllDocuments = async () => {
    const result = await fetchData("getdocuments?showActive=0");
    if (result?.code === 200) {
      setDocumentList(result.data);
    }
  };

  React.useEffect(() => {
    getAllDocuments();
    const minLoadingTimer = setTimeout(() => {
      setMinLoading(false);
    }, 1500);

    return () => clearTimeout(minLoadingTimer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isLoading = minLoading || loading["getdocuments?showActive=0"];

  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        width="100%"
        height="100%"
        overflow="hidden"
      >
        <HeaderSection isLoading={isLoading} />
        <DocumentList documents={documentList} isLoading={isLoading} />
      </Box>
    </>
  );
};
export default Documents;
